import React from 'react';

export default function Footer() {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index.html" className="logo d-flex flex-column align-items-start text-start">
              <img src="/images/logo-light.svg" alt="Logo" className="mb-1 logo-footer" />
              <span className="sitename">
                <span className="first-word">Railing</span> World
              </span>
            </a>
            <div className="footer-contact pt-3">
              <p>No. 16, Jay sardar estate, st. no. 3,Ramnath ind. zone,</p>
              <p>B/h Murlidhar way bridge National highway,Rajkot - 360002.</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 96029 60239 | +91 99675 68868</span></p>
              <p><strong>Email:</strong> <span>railingworld08@gmail.com</span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="https://wa.me/919602960239" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-whatsapp"></i>
              </a>
              <a href="https://www.facebook.com/share/1FdBjryTo7/" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.instagram.com/railing_world?igsh=MTllOTNrZGo0ZWhkcQ==" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://www.threads.net/@railing_world" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-twitter-x"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/About">About us</a></li>
              <li><a href="/Product">Product</a></li>
              <li><a href="/category">Category</a></li>
              <li><a href="/Contact">Contact</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-6 footer-links">
            <h4>Product we offer</h4>
            <ul>
              <li><a href="/category">Aluminium Hand Rail</a></li>
              <li><a href="/category">Aluminium Railing Bracket</a></li>
              <li><a href="/category">Aluminium Railing Accessories</a></li>
              <li><a href="/category">S.S. Glass Railing Bracket</a></li>
              <li><a href="/category">Glass Railing Pipe</a></li>
              <li><a href="/category">Invisible Grill Accessories</a></li>
            </ul>
          </div>

          {/* <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
            <form action="forms/newsletter.php" method="post" className="php-email-form">
              <div className="newsletter-form">
                <input type="email" name="email" placeholder="Enter your email" />
                <input type="submit" value="Subscribe" />
              </div>
              <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">Your subscription request has been sent. Thank you!</div>
            </form>
          </div> */}
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">Railing World</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
          {/* All the links in the footer should remain intact. */}
          {/* You can delete the links only if you've purchased the pro version. */}
          {/* Licensing information: https://bootstrapmade.com/license/ */}
          {/* Purchase the pro version with working PHP/AJAX contact form: [buy-url] */}
          Designed and Developed by <a href="/">Hardy Jadav</a>
        </div>
      </div>
    </footer>
  );
}